import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Registration from "./components/Registration/Registration";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Team from "./components/Team/Team";
import WebPricing from "./components/WebPricing/PricingCard1";
import RoboticsPricing from "./components/RoboticsPricing/RoboticsCard"
import ThreeDWebPricing from "./components/ThreeDWebPricing/ThreeDWebCard"
import ThreeDModelingPricing from "./components/ThreeDModelingPricing/ThreeDModelingCard"
import JusticeTechPricing from "./components/JusticeTechPricing/JusticeTechCard"
import AppropTechPricing from "./components/AppropTechPricing/AppropTechCard"

// import Impact from "./components/Impact/Impact";
import Contact from "./components/Contact/Contact";
import Lab from "./components/Lab/AboutLab";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ImpactHome from "./components/Activities/ImpactHome";
import Impact from "./components/Impact/Impact"
import Workshop from "./components/Workshops/Workshop";
import Senior from "./components/Seniors/Senior";
import Neighborhood from "./components/Neighborhood/Neighborhood";
import Support from "./components/Support/Support";
import Story from "./components/Story/Story";
import Testimonial from "./components/Testimonials/Testimonial";
import Partners from "./components/Partners/Partners";
import Mission from "./components/Mission/Mission";
import Afterschool from "./components/Afterschool/Afterschool";
import Ambassadors from "./components/Ambassadors/Ambassadors";
import TechPal from "./components/TechPal/TechPal";
import Camps from "./components/Camps/Camps";
import Stats from "./components/Stats/Stats";
import TrainingsTiers from "./components/TrainingsTiers/TrainingsTiers";
import Tiers from "./components/Tiers/Tiers.js";



function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Projects />} />
           <Route path="/tiers" element={<Tiers />} />
           <Route path="/programs/trainings-tiers" element={<TrainingsTiers />} />
          <Route path="/about/who-we-are" element={<About />} />
          <Route path="/registration" element={<Registration/>} />
          <Route path="/impact" element={<ImpactHome />} />
          <Route path="/team" element={<Team/>} />
          <Route path="/about/testimonials" element={<Testimonial/>} />
          <Route path="/contact" element={<Contact />} />          
          <Route path="/web-pricing" element={<WebPricing />} />
          <Route path="/robotics-pricing" element={<RoboticsPricing />} />
          <Route path="/three-d-web-pricing" element={<ThreeDWebPricing />} />
          <Route path="/three-d-modeling-pricing" element={<ThreeDModelingPricing />} />
          <Route path="/justice-tech-pricing" element={<JusticeTechPricing />} />
          <Route path="/approp-tech-pricing" element={<AppropTechPricing />} />
          <Route path="/lab" element={<Lab />} />              
          <Route path="/programs/syep-internship" element={<Impact />} />
          <Route path="/programs/workshops" element={<Workshop />} />
          <Route path="/programs/after-school" element={<Afterschool />} />
          <Route path="/programs/ambassadors" element={<Ambassadors />} />
          <Route path="/programs/tech-pal" element={<TechPal />} />
          <Route path="/programs/tech-camps" element={<Camps />} />
          <Route path="/programs/senior-citizens" element={<Senior />} />
          <Route path="/programs/code-and-soil" element={<Neighborhood />} />
          <Route path="/support" element={<Support />} />
          <Route path="/about/our-story" element={<Story />} />
          <Route path="/about/our-partners" element={<Partners />} />
          <Route path="/about/our-mission" element={<Mission />} />          
          <Route path="/about/impact" element={<Stats />} />            
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
